import CountUp from "react-countup";

export function AdminPageHeader({ title, subtitle }) {
    return (
        <div className="wt-admin-right-page-header clearfix">
            <h2>{title}</h2>
            <div className="breadcrumbs"><span>Admin</span><span>{subtitle || title}</span></div>
        </div>
    );
}

export function AdminPanel({ title, icon = "fa fa-list", children, right }) {
    return (
        <div className="panel panel-default">
            <div className="panel-heading wt-panel-heading p-a20 d-flex justify-content-between align-items-center">
                <h4 className="panel-tittle m-a0"><i className={icon} /> {title}</h4>
                {right}
            </div>
            <div className="panel-body wt-panel-body p-a20">
                {children}
            </div>
        </div>
    );
}

export function AdminStatCard({ icon, className = "gradi-1", value, label }) {
    return (
        <div className="col-xl-3 col-lg-6 col-md-12 mb-3">
            <div className="panel panel-default">
                <div className={`panel-body wt-panel-body ${className} dashboard-card`}>
                    <div className="wt-card-wrap">
                        <div className="wt-card-icon"><i className={icon} /></div>
                        <div className="wt-card-right counter">
                            <CountUp end={Number(value || 0)} duration={1} />
                        </div>
                        <div className="wt-card-bottom">
                            <h4 className="m-b0">{label}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function StatusBadge({ status }) {
    const text = status || "unknown";
    const className = text === "published" || text === "active" || text === "verified"
        ? "twm-bg-green"
        : text === "pending_review" || text === "submitted"
            ? "twm-bg-yellow"
            : "twm-bg-red";
    return <div className="twm-jobs-category"><span className={className}>{text.replace(/_/g, " ")}</span></div>;
}

export function EmptyState({ text }) {
    return <div className="p-a30 text-center">{text}</div>;
}

export function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString();
}
